import { ReactNode } from 'react';

import classNames from 'classnames';

import useStyles from './FormLinkButton.styles';

/**
 * Свойства компонента {@link FormLinkButton}
 */
interface FormLinkButtonProps {
  /**
   * Дочерние элементы, которые будут отображены внутри кнопки.
   */
  children: ReactNode;

  /**
   * Вариант стиля кнопки. Может быть 'primary' или 'tertiary'.
   *
   * @defaultValue `'primary'`
   */
  variant?: 'primary' | 'tertiary';
}

/**
 * Компонент кнопки-ссылки для форм.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри кнопки.
 * @param variant - Вариант стиля кнопки. Может быть 'primary' или 'tertiary'.
 * @returns  Кнопка-ссылка с указанными свойствами.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormLinkButtonProps}
 */
export const FormLinkButton = ({
  children,
  variant = 'primary',
}: FormLinkButtonProps) => {
  const { classes } = useStyles();

  return (
    <button
      type="submit"
      className={classNames(
        classes.linkButton,
        variant === 'tertiary' && classes.linkButton_tertiary,
      )}
    >
      {children}
    </button>
  );
};
